import React, { memo } from 'react'
import {
  LuChevronRight,
  LuChevronsLeft,
  LuChevronLeft,
  LuChevronsRight
} from 'react-icons/lu'

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  // Function to handle page change
  const handlePageChange = page => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page)
    }
  }

  // Function to render the page buttons
  const renderPageNumbers = () => {
    const pageNumbers = []
    const maxPagesToShow = 5
    const isTruncated = totalPages > maxPagesToShow

    // First two pages
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
      pageNumbers.push(i)
    }

    // Truncation for the beginning
    if (isTruncated && currentPage > 4) {
      pageNumbers.push('...')
    }

    // Middle pages around the current page
    for (
      let i = Math.max(3, currentPage - 1);
      i <= Math.min(totalPages - 2, currentPage + 1);
      i++
    ) {
      pageNumbers.push(i)
    }

    // Truncation for the end
    if (isTruncated && currentPage < totalPages - 3) {
      pageNumbers.push('...')
    }

    // Last two pages
    for (let i = Math.max(totalPages - 1, 3); i <= totalPages; i++) {
      if (i > 2) {
        pageNumbers.push(i)
      }
    }

    return pageNumbers
  }

  const pageNumbers = renderPageNumbers()

  return (
    <div className='flex justify-center pt-4'>
      <nav
        className='flex flex-row flex-nowrap justify-between md:justify-center items-center'
        aria-label='Pagination'
      >
        <button
          className='flex w-8 h-8 mx-1 justify-center items-center rounded-[8px] border border-[#fff] bg-transparent text-white hover:bg-[#37404a]/50 transition duration-300'
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          <LuChevronsLeft />
        </button>
        <button
          className='flex w-8 h-8 mx-1 justify-center items-center rounded-[8px] border border-[fff] bg-transparent text-white hover:bg-[#37404a]/50 transition duration-300'
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <LuChevronLeft />
        </button>

        {pageNumbers.map((page, index) => (
          <button
            key={index}
            className={`flex w-8 h-8 mx-1 justify-center items-center rounded-[8px] border border-[#fff]  ${
              currentPage === page
                ? 'bg-[#fff] text-black'
                : 'bg-transparent text-white hover:bg-[#37404a]/50 transition duration-300'
            }`}
            onClick={() => handlePageChange(page)}
            disabled={page === '...'}
            title={`Page ${page}`}
          >
            {page}
          </button>
        ))}

        <button
          className='flex w-8 h-8 mx-1 justify-center items-center rounded-[8px] border border-[#fff] bg-transparent text-white hover:bg-[#37404a]/50 transition duration-300'
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <LuChevronRight />
        </button>
        <button
          className='flex w-8 h-8 mx-1 justify-center items-center rounded-[8px] border border-[#fff] bg-transparent text-white hover:bg-[#37404a]/50 transition duration-300'
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <LuChevronsRight />
        </button>
      </nav>
    </div>
  )
}

export default memo(Pagination)